// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.x2g4Y0ZpdjZRUe {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 32px;
}
@media only screen and (min-width: 751px) and (max-width: 900px), only screen and (max-width: 750px), only screen and (max-width: 600px) {
  .x2g4Y0ZpdjZRUe {
    display: block;
    margin-top: 0;
    margin-left: 0;
  }
}
.x2g4Y0ZpdjZRUe ul {
  padding: 0;
}
@media only screen and (min-width: 751px) and (max-width: 900px), only screen and (max-width: 750px), only screen and (max-width: 600px) {
  .x2g4Y0ZpdjZRUe ul {
    padding-top: 0;
    padding-bottom: 20px;
  }
}
.mXeu3PYm5OBAjA {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
  margin-bottom: 24px;
}
@media only screen and (min-width: 751px) and (max-width: 900px), only screen and (max-width: 750px), only screen and (max-width: 600px) {
  .mXeu3PYm5OBAjA {
    justify-content: flex-start;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"templateBreadCrumb": `x2g4Y0ZpdjZRUe`,
	"viewTemplate": `mXeu3PYm5OBAjA`
};
export default ___CSS_LOADER_EXPORT___;
